import { useEffect, useState } from 'react';
import { roles } from '@constants/correspondent';
import { getCashiersWithSubsidiaryRecords } from '@shared/services/api/supervisorService';

const filterRecordsBySubsidiary = (records, subsidiary, roleName) => {
  return records.filter((record) => {
    if (!record) {
      return false;
    }
    if (
      !subsidiary ||
      [
        roles.rotativeSupervisor,
        roles.correspondentAnalyst,
        roles.correspondentAdmin,
        roles.correspondentConsultant,
      ].includes(roleName)
    ) {
      return true;
    }
    return record.subsidiary_id == subsidiary && !record.end_date;
  });
};

const mapRecordsWithName = (records, name, mail) => {
  return records.map((record) => ({
    ...record,
    name,
    mail,
  }));
};

const removeDuplicatesById = (records) => {
  const seenIds = new Set();
  return records.filter((record) => {
    if (seenIds.has(record.profile_id)) {
      return false;
    }
    seenIds.add(record.profile_id);
    return true;
  });
};

const useFetchCashiers = (subsidiary, roleName) => {
  const [options, setOptions] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const result = await getCashiersWithSubsidiaryRecords();
        const data = result?.data || [];

        const validOptions = data.reduce((acc, option) => {
          const { first_name: firstName = '', last_name: lastName = '', mail } = option;
          const name = `${firstName} ${lastName}`;

          const recordsInSubsidiary = filterRecordsBySubsidiary(
            option.subsidiary_registers || [],
            subsidiary,
            roleName
          );
          const recordsWithName = mapRecordsWithName(recordsInSubsidiary, name, mail);
          return [...acc, ...recordsWithName];
        }, []);

        setOptions(removeDuplicatesById(validOptions));
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };

    fetchData();
  }, [subsidiary, roleName]);

  return options;
};

export default useFetchCashiers;
